import { render, staticRenderFns } from "./ClustersBase.vue?vue&type=template&id=0f419199&"
import script from "./ClustersBase.vue?vue&type=script&lang=js&"
export * from "./ClustersBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports